import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

import {ContentWrapper} from 'src/app/layout/ContentWrapper';

import NotificationRuleForm from '../Shared/NotificationRuleForm';
import {NotificationRuleDocumentTitle} from '../notificationRuleHelpers';

export const CreateNotificationRulePage = () => {
  useSetDocumentTitle(NotificationRuleDocumentTitle);

  return (
    <ContentWrapper>
      <NotificationRuleForm id={undefined} mode="create" />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.NotificationRuleCreate(),
  element: <CreateNotificationRulePage />,
  module: ModuleEnum.NotificationRules,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
});

export default CreateNotificationRulePage;
